<div id="content" class="extensible">
  <app-locations-management [relatable_type]="null" [relatable_id]="null" [choose_relatable]="true" [from_locations_page]="true" />
</div>
